import { render, staticRenderFns } from "./RecommendArticle.vue?vue&type=template&id=94c15238&scoped=true&"
import script from "./RecommendArticle.vue?vue&type=script&lang=js&"
export * from "./RecommendArticle.vue?vue&type=script&lang=js&"
import style0 from "./RecommendArticle.vue?vue&type=style&index=0&id=94c15238&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c15238",
  null
  
)

export default component.exports